import React from "react";
import { Buffer } from "buffer";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./screen/dashboard/Dashboard";
import ListActiveStock from "./screen/stock/ListActiveStock";
import PurchaseOrderPart from "./screen/bengkel/PurchaseOrderPart";
import ListTransferStock from "./screen/stock/ListTransferStock";
import TransferStock from "./screen/stock/TransferStock";
import ListActiveOrder from "./screen/order/ListClosedOrder";
import CreateOrder from "./screen/order/CreateOrder";
import CreateMultiOrder from "./screen/order/CreateMultiOrder";
import UpdateOffer from "./screen/offer/UpdateOffer";
import NewTitleTransferTax from "./screen/document/NewTitleTransferTax";
import TransferTaxControl from "./screen/document/TransferTaxControl";
import UploadDocEngine from "./screen/document/UploadDocEngine";
import UploadNotice from "./screen/document/UploadNotice";
import ListOffer from "./screen/offer/ListOffer";
import ListGeneralOffer from "./screen/offer/ListGeneralOffer";
import ForceAutoClosing from "./screen/offer/ForceAutoClosing";
import ListPrebooking from "./screen/offer/ListPrebooking";
import Warehouse from "./screen/setting/Warehouse";
import DdmsInvoice from "./screen/document/DdmsInvoice";
import DdmsBast from "./screen/document/DdmsBast";
import ImportStockWisesa from "./screen/stock/ImportStockWisesa";
import EngineNumberMonitoring from "./screen/stock/EngineNumberMonitoring";
import Track from "./screen/setting/Track";
import SendFinalSale from "./screen/order/SendFinalSale";
import UnderConstruct from "./screen/UnderConstruct";
import Login from "./screen/auth/Login";
import LoginOld from "./screen/auth/LoginOld";
import UploadInvoice from "./screen/tax/UploadInvoice";
import Fulfillment from "./screen/setting/Fulfillment";
import StopOrder from "./screen/setting/StopClosing";
import SettingServiceBureau from "./screen/setting/SettingServiceBureau";
import SourceStockData from "./screen/stock/SourceStockData";
import UpdateJsonStock from "./screen/stock/UpdateJsonStock";
import ShippingCost from "./screen/setting/ShippingCost";
import AddShippingCost from "./screen/setting/AddShippingCost";
import OrderPolicy from "./screen/setting/OrderPolicy";
import AddOrderPolicy from "./screen/setting/AddOrderPolicy";
import ListCashbackAgent from "./screen/offer/ListCashbackAgent";
import BookUnit from "./screen/offer/BookUnit";
import LogAutomaticClosing from "./screen/offer/LogAutomaticClosing";
import UpdateStatusStock from "./screen/stock/UpdateStatusStock";
import CancelOfferLoan from "./screen/offer/CancelOfferLoan";
import CancelOfferLoanOrder from "./screen/offer/CancelOfferLoanOrder";
import CancelOffer from "./screen/offer/CancelOffer";
import ReactiveOffer from "./screen/offer/ReactiveOffer";
import UpdateDdmsInvoice from "./screen/tax/UpdateDdmsInvoice";
import RemoveQcOffer from "./screen/offer/RemoveQcOffer";
import MonitoringOrder from "./screen/order/MonitoringOrder";
import UploadBillKPB from "./screen/bengkel/UploadBillKPB";
import ListLoanBpkb from "./screen/loan/ListLoanBpkb";
import ListDeliveryOrder from "./screen/delivery/ListDeliveryOrder";
import CreateDeliveryOrder from "./screen/delivery/CreateDeliveryOrder";
import CreateDeliveryOrderManual from "./screen/delivery/CreateDeliveryOrderManual";
import DeliveryHandover from "./screen/delivery/DeliveryHandover";
import DocumentHandover from "./screen/document/DocumentHandover";
import PurchaseStock from "./screen/stock/PucrhaseStock";
import ImportPucrhaseStock from "./screen/stock/ImportPucrhaseStock";
import InsertStockDaya from "./screen/stock/InsertStockDaya";
import InsertStockChery from "./screen/stock/InsertStockChery";
import TaxOutGenerateCsv from "./screen/tax/TaxOutGenerateCsv";
import TaxOutSync from "./screen/tax/TaxOutSync";
import TaxOutTransferData from "./screen/tax/TaxOutTransferData";
import TaxOutManual from "./screen/tax/TaxOutManual";
import TaxInTransfer from "./screen/tax/TaxInTransfer";
import TaxInManualCredit from "./screen/tax/TaxInManualCredit";
import TaxInManual from "./screen/tax/TaxInManual";
import SettingDriver from "./screen/setting/SettingDriver";
import SettingDeliveryVehicle from "./screen/setting/SettingDeliveryVehicle";
import { Provider } from "react-redux";
import { store } from "./redux";
import Cookies from "universal-cookie";
import OrderAssigment from "./screen/bbn/OrderAssigment";
import PaymentApproval from "./screen/bbn/PaymentApproval";

import SettingDealer from "./screen/setting/SettingDealer";
import Supplier from "./screen/setting/Supplier";
import UpdateStock from "./screen/stock/UpdateStock";

const cookies = new Cookies();

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/login" caseSensitive={false} element={<Login />} />
          <Route path="/login-old" caseSensitive={false} element={<LoginOld />} />
          <Route path="/:dealerCode/dashboard" caseSensitive={false} element={<Dashboard />} />
          <Route path="/:dealerCode/purchase-stock" caseSensitive={false} element={<PurchaseStock />} />
          <Route path="/:dealerCode/purchase-multiple-stock" caseSensitive={false} element={<ImportPucrhaseStock />} />
          <Route path="/:dealerCode/purchase-order-part" caseSensitive={false} element={<PurchaseOrderPart />} />
          <Route path="/:dealerCode/list-active-stock" caseSensitive={false} element={<ListActiveStock />} />
          <Route path="/:dealerCode/update-status-stock" caseSensitive={false} element={<UpdateStatusStock />} />
          <Route path="/:dealerCode/update-variant-stock" caseSensitive={false} element={<UpdateStock />} />
          <Route path="/:dealerCode/warehouse-stock-transfer" caseSensitive={false} element={<TransferStock />} />
          <Route path="/:dealerCode/list-stock-transfer" caseSensitive={false} element={<ListTransferStock />} />
          <Route path="/:dealerCode/list-closed-order" caseSensitive={false} element={<ListActiveOrder />} />
          <Route path="/:dealerCode/create-order" caseSensitive={false} element={<CreateOrder />} />
          <Route path="/:dealerCode/create-multi-order" caseSensitive={false} element={<CreateMultiOrder />} />
          <Route path="/:dealerCode/send-final-sale" caseSensitive={false} element={<SendFinalSale />} />
          <Route path="/:dealerCode/update-offer" caseSensitive={false} element={<UpdateOffer />} />
          <Route path="/:dealerCode/new-title-transfer-tax" caseSensitive={false} element={<NewTitleTransferTax />} />
          <Route path="/:dealerCode/transfer-tax-control" caseSensitive={false} element={<TransferTaxControl />} />
          <Route path="/:dealerCode/upload-doc-engine" caseSensitive={false} element={<UploadDocEngine />} />
          <Route path="/:dealerCode/upload-notice" caseSensitive={false} element={<UploadNotice />} />
          <Route path="/:dealerCode/list-offer" caseSensitive={false} element={<ListOffer />} />
          <Route path="/:dealerCode/list-general-offer" caseSensitive={false} element={<ListGeneralOffer />} />
          <Route path="/:dealerCode/list-prebooking" caseSensitive={false} element={<ListPrebooking />} />
          <Route path="/:dealerCode/force-autoclosing" caseSensitive={false} element={<ForceAutoClosing />} />
          <Route path="/:dealerCode/list-cashback-agent" caseSensitive={false} element={<ListCashbackAgent />} />
          <Route path="/:dealerCode/setting-warehouse" caseSensitive={false} element={<Warehouse />} />
          <Route path="/:dealerCode/get-ddms-invoice" caseSensitive={false} element={<DdmsInvoice />} />
          <Route path="/:dealerCode/get-ddms-bast" caseSensitive={false} element={<DdmsBast />} />
          <Route path="/:dealerCode/import-stock-wisesa" caseSensitive={false} element={<ImportStockWisesa />} />
          <Route path="/:dealerCode/engine-number-monitoring" caseSensitive={false} element={<EngineNumberMonitoring />} />
          <Route path="/:dealerCode/setting-track" caseSensitive={false} element={<Track />} />
          <Route path="/:dealerCode/setting-fulfillment" caseSensitive={false} element={<Fulfillment />} />
          <Route path="/:dealerCode/setting-stop-closing" caseSensitive={false} element={<StopOrder />} />
          <Route path="/:dealerCode/setting-service-bureau" caseSensitive={false} element={<SettingServiceBureau />} />
          <Route path="/:dealerCode/publish-stock" caseSensitive={false} element={<SourceStockData />} />
          <Route path="/:dealerCode/update-json-stock" caseSensitive={false} element={<UpdateJsonStock />} />
          <Route path="/:dealerCode/shipping-cost" caseSensitive={false} element={<ShippingCost />} />
          <Route path="/:dealerCode/add-shipping-cost" caseSensitive={false} element={<AddShippingCost />} />
          <Route path="/:dealerCode/book-unit" caseSensitive={false} element={<BookUnit />} />
          <Route path="/:dealerCode/log-automatic-closing" caseSensitive={false} element={<LogAutomaticClosing />} />
          <Route path="/:dealerCode/order-policy" caseSensitive={false} element={<OrderPolicy />} />
          <Route path="/:dealerCode/add-order-policy" caseSensitive={false} element={<AddOrderPolicy />} />

          <Route path="/:dealerCode/cancel-offer-loan" caseSensitive={false} element={<CancelOfferLoan />} />
          <Route path="/:dealerCode/cancel-order-loan" caseSensitive={false} element={<CancelOfferLoanOrder />} />

          <Route path="/:dealerCode/cancel-offer" caseSensitive={false} element={<CancelOffer />} />
          <Route path="/:dealerCode/removeQc-offer" caseSensitive={false} element={<RemoveQcOffer />} />
          <Route path="/:dealerCode/reactive-offer" caseSensitive={false} element={<ReactiveOffer />} />

          <Route path="/:dealerCode/stock/insert/stock-daya" caseSensitive={false} element={<InsertStockDaya />} />
          <Route path="/:dealerCode/stock/insert/stock-chery" caseSensitive={false} element={<InsertStockChery />} />

          <Route path="/:dealerCode/list-delivery-order" caseSensitive={false} element={<ListDeliveryOrder />} />
          <Route path="/:dealerCode/create-delivery-order/amren" caseSensitive={false} element={<CreateDeliveryOrder />} />
          <Route path="/:dealerCode/create-delivery-order/manual" caseSensitive={false} element={<CreateDeliveryOrderManual />} />
          <Route path="/:dealerCode/delivery-handover" caseSensitive={false} element={<DeliveryHandover />} />

          <Route path="/:dealerCode/update-ddms-invoice" caseSensitive={false} element={<UpdateDdmsInvoice />} />
          <Route path="/:dealerCode/document/handover" caseSensitive={false} element={<DocumentHandover />} />

          <Route path="/:dealerCode/monitoring-order" caseSensitive={false} element={<MonitoringOrder />} />
          <Route path="/:dealerCode/upload-bill-kpb" caseSensitive={false} element={<UploadBillKPB />} />

          <Route path="/:dealerCode/tax-out/generate-csv" caseSensitive={false} element={<TaxOutGenerateCsv />} />
          <Route path="/:dealerCode/tax-out/syncronisation" caseSensitive={false} element={<TaxOutSync />} />
          <Route path="/:dealerCode/tax-out/transfer-tax-data" caseSensitive={false} element={<TaxOutTransferData />} />
          <Route path="/:dealerCode/tax-out/manual/insert" caseSensitive={false} element={<TaxOutManual />} />
          <Route path="/:dealerCode/upload-invoice" caseSensitive={false} element={<UploadInvoice />} />

          <Route path="/:dealerCode/tax-in/transfer-data" caseSensitive={false} element={<TaxInTransfer />} />
          <Route path="/:dealerCode/tax-in/manual/insert" caseSensitive={false} element={<TaxInManual />} />
          <Route path="/:dealerCode/tax-in/credit/manual/insert" caseSensitive={false} element={<TaxInManualCredit />} />

          <Route path="/:dealerCode/setting-driver" caseSensitive={false} element={<SettingDriver />} />
          <Route path="/:dealerCode/setting-delivery-vehicle" caseSensitive={false} element={<SettingDeliveryVehicle />} />

          <Route path="/:dealerCode/bbn/list-order" caseSensitive={false} element={<OrderAssigment />} />
          <Route path="/:dealerCode/bbn/payment-approval" caseSensitive={false} element={<PaymentApproval />} />

          <Route path="/:dealerCode/setting-dealer" caseSensitive={false} element={<SettingDealer />} />
          <Route path="/:dealerCode/setting-supplier" caseSensitive={false} element={<Supplier />} />

          <Route path="/:dealerCode/loan/bpkb" caseSensitive={false} element={<ListLoanBpkb />} />

          <Route path="/under-construct" caseSensitive={false} element={<UnderConstruct />} />
          <Route
            path="/"
            caseSensitive={false}
            element={cookies?.get("_t") ? <Navigate to={"/" + JSON.parse(Buffer?.from(cookies?.get("_dd"), "base64")?.toString()).DealerCode?.replace(/#/g, "-") + "/dashboard"} /> : <Login />}
          />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
